module.exports = "/_next/static/images/IconParkingReview-92014c4acc88a82f5f4bdfa8efd77d19.svg";